import { render, staticRenderFns } from "./secret-dialog.vue?vue&type=template&id=4f8980b5&scoped=true&"
import script from "./secret-dialog.vue?vue&type=script&lang=js&"
export * from "./secret-dialog.vue?vue&type=script&lang=js&"
import style0 from "./secret-dialog.vue?vue&type=style&index=0&id=4f8980b5&prod&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4f8980b5",
  null
  
)

export default component.exports